// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"15b504bd","2103":"56fd70a8","2408":"e39ba47f","2852":"7bcad399","3918":"c73ab327","4007":"59c10348","7781":"2df2e03c","8432":"7b8c9f5d"}[chunkId] + ".css";
};